module.exports = __webpack_public_path__ + "img/depression.2319a533.png";